export default function rollbarBookmarklet(customerToken: string) {
  return `javascript:void(
    (
      async function rollbarBookmarklet() {
        const findPropNode = (label) => {
          const table = document.querySelector('.table.table-bordered');
          if (!table) {
            return null;
          }
          const th = [...table.querySelectorAll('th')].find(node => node.innerText === label);
          return th ? th.parentElement.querySelector('td') : null;
        };

        const loadDependency = async (src) => {
          return new Promise((resolve) => {
            const fflateScript = document.createElement('script');
            fflateScript.src = src;
            document.body.appendChild(fflateScript);
            fflateScript.addEventListener('load', resolve);
          });
        };

        const decodeInternal = (param) => {
          const base64String = decodeURIComponent(param);
          const uint8Array = Uint8Array.from(atob(base64String), c => c.charCodeAt(0));
          const decompressed = fflate.decompressSync(uint8Array);
          const origText = fflate.strFromU8(decompressed);
          return JSON.parse(origText);
        };

        await loadDependency('https://unpkg.com/fflate');

        const urlNode = findPropNode('URL');

        if (!urlNode) {
          alert("It seems you're not inside a Rollbar error page!");
          return;
        }

        const siteIdNode = findPropNode('site_id');
        const tr = urlNode.parentElement;

        if (siteIdNode) {
          const siteId = siteIdNode.innerText;
          try {
            var params = new URLSearchParams();
            params.set('site_id', siteId);

            const response = await fetch(
              'https://internal.datocms.com/customers/login-url?' + params.toString(),
              { headers: { Authorization: 'Bearer ${customerToken}' } },
            );

            const { url } = await response.json();

            const enterProjectTr = document.createElement('tr');
            enterProjectTr.innerHTML = '<th>DatoCMS Project</th><td><a href="' + url + '" target="_blank">Click to enter the project as owner</a></td>';
            tr.parentNode.insertBefore(enterProjectTr, tr.nextSibling);
          } catch(e) {}
        }

        const url = urlNode.innerText.split(' ')[1];
        const urlParams = new URLSearchParams(url.split('?')[1]);
        const internalParam = urlParams.get('_b64_internal');
        const bodyNode = findPropNode('request.body');

        const query =
          internalParam
          ? decodeInternal(internalParam)
          : JSON.parse(bodyNode.innerHTML);

        if (query.variables) {
          const variablesTr = document.createElement('tr');
          variablesTr.innerHTML = '<th>GraphQL Variables</th><td><pre contenteditable style="max-height: 200px; overflow: auto;">' + JSON.stringify(query.variables, null, 2) + '</pre></td>';
          tr.parentNode.insertBefore(variablesTr, tr.nextSibling);
        }

        if (query.query) {
          const queryTr = document.createElement('tr');
          queryTr.innerHTML = '<th>GraphQL Query</th><td><pre contenteditable style="max-height: 200px; overflow: auto;">' + query.query.replace(/ /g, '&nbsp;') + '</pre></td>';
          tr.parentNode.insertBefore(queryTr, tr.nextSibling);
        }
      }
    )()
  )`
    .split(/\n/)
    .map((l) => l.replace(/^ */, ''))
    .join(' ');
}
